import * as yup from 'yup'
import { PersonalDetailsType } from '../components/ApplicationForm/ApplicationFormContext'

interface Validator {
  getValidator: (isInLoqateExperiment?: boolean) => yup.AnySchema
  validateState: (state: PersonalDetailsType) => boolean
}

const EmailAddressValidator = (): Validator => {
  const schema = yup.object().shape({
    emailAddress: yup.string()
      .required('Please enter your email address')
      .email('Please enter a valid email address')
      .label('Email address')
      .max(100)
  })

  return {
    getValidator: () => schema,
    validateState: (personalDetails: PersonalDetailsType) => schema.isValidSync({
      emailAddress: personalDetails?.emailAddress
    })
  }
}

export default EmailAddressValidator
